import React from 'react';
import { useQuery } from '@tanstack/react-query';

import { Separator } from '@epoch-ui/components/Separator';

import { useEditableEvent } from '../../hooks/useEditableEvent';
import { getEditEventFeedbackData } from '../../api/feedback/getEditEventFeedbackData';
import { eventEditorQueryKeys } from '../../queryKeys';

import { FeedbackFormQuestionsSection } from './sections/FeedbackFormQuestionsSection';
import { FeedbackFormResponsesSection } from './sections/FeedbackFormResponsesSection';
import { FeedbackProgressSection } from './sections/FeedbackProgressSection';

export const EditEventFeedback = (): React.ReactElement => {
  const { id, feedbackEnable } = useEditableEvent();
  const { data } = useQuery({
    queryKey: eventEditorQueryKeys.eventFeedback(Number(id)),
    queryFn: () => getEditEventFeedbackData(Number(id)),
    enabled: typeof Number(id) === 'number' && Number(id) > 0
  });

  return (
    <div className="tw-space-y-10">
      {feedbackEnable && data && (
        <>
          {/* Response Rate Progress Bar Section */}
          <FeedbackProgressSection data={data} />

          <Separator />

          {/* Feedback Form Responses Section */}
          <FeedbackFormResponsesSection data={data} />

          <Separator />
        </>
      )}

      {/* Feedback Form Questions Section */}
      <FeedbackFormQuestionsSection />
    </div>
  );
};
